import { BaseStore } from '@fuselab/ui-fabric/models';
import { preference, user } from '@fuselab/ui-fabric/reducers';
import { combineReducers } from 'redux';

export default combineReducers<BaseStore>({
  user,
  preference
});
